import { DEFAULT_PAGINATION_LIMIT } from "../../../../../globalConstants";

export const STRINGS = {
  ADD_MODE: "A",
  EDIT_MODE: "E",
  INTERNAL_LABEL: "Internal",
  EXTERNAL_LABEL: "External",
  DEFAULT_PAGINATION_LIMIT: DEFAULT_PAGINATION_LIMIT,
  MODAL_MODE: {
    ADD: "A",
    EDIT: "E",
    DELETE: "D",
    SUCCESS: "S",
    FAILURE: "F",
    DEFAULT: "",
  },
  MODAL_SIZE: {
    X_SMALL: "xs",
    SMALL: "sm",
    MEDIUM: "md",
    LARGE: "lg",
  },
};

export const SORT_OPTS = [
  { label: "Newest to Oldest", value: "-created_at", default: true },
  { label: "Oldest to Newest", value: "created_at" },
];
